export default function (source) {
    if (source == null || source == undefined || source == '') {
        return true;
    } else {
        return false;
    }
}